import React, { useState } from 'react';
import ResetModal from './ResetModal';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

export interface ResetButtonProps {
  flow?: 'eligiblity' | 'takaful';
}

const ResetButton: React.FC<ResetButtonProps> = ({ flow = 'eligiblity' }) => {
  const router = useRouter();
  const [resetContext, setResetContext] = useState<boolean>(false);

  const { t } = useTranslation('common');

  const pathNameToRedirect = (flowPassed: string) => {
    switch (flowPassed) {
      case 'eligiblity':
        return '/eligibilityV2/reset';
      case 'takaful':
        return '/eligibility/takaful/reset';
      default:
        return '/eligibilityV2/reset';
    }
  };

  return (
    <>
      <ResetModal
        open={resetContext}
        onClose={() => setResetContext(false)}
        onClick={() => router.push({ pathname: pathNameToRedirect(flow) })}
      />
      <div
        onClick={() => setResetContext(true)}
        className="underline text-gray-400 text-xs m-2 cursor-pointer"
      >
        {t('reset_form')}
      </div>
    </>
  );
};

export default ResetButton;
